import { render, staticRenderFns } from "./IrInvoiceCharges.vue?vue&type=template&id=0273b8a0&"
import script from "./IrInvoiceCharges.vue?vue&type=script&lang=js&"
export * from "./IrInvoiceCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports